import VisualReports from "./VisualReports";
export default VisualReports;